import { z } from 'zod';
import { WorkerSelectionSchema } from './workerBulk.schema.js';

/* ===========================================================================
 * "EXPORT SELECTED" — the bodies of the two list exports.
 *
 * POST, because the request is a SELECTION and a few hundred ids do not belong
 * in a query string a proxy will truncate. The server reads the rows itself and
 * lays them out; nothing the client sends is written into the file except the
 * ids that pick the rows.
 * ======================================================================== */

/**
 * The employee roster's export takes the SAME selection the roster's bulk
 * actions take — explicit `employeeIds`, or "every worker matching the filter"
 * — and resolves it through the same scope-checked resolver. A second shape
 * would be a second answer to "which people did I select?", and the bulk bar
 * already learned what that costs (see `WorkerSelectionFilterSchema`).
 */
export const EmployeeExportSchema = z.object({
  selection: WorkerSelectionSchema,
});
export type EmployeeExportBody = z.infer<typeof EmployeeExportSchema>;

/**
 * The worksite register is client-side and unpaginated, so "selected" is only
 * ever a list of ids. Capped to bound the query, not as a product limit — the
 * largest tenant has a few dozen sites.
 */
export const WorksiteExportSchema = z.object({
  ids: z.array(z.string().min(1).max(64)).min(1).max(2000),
});
export type WorksiteExportBody = z.infer<typeof WorksiteExportSchema>;
